/**
 * Order rules the UI applies before asking the API. The server stays the authority; these mirror
 * it (backend controllers/patient/order_controller.py `_CANCELLABLE`) and the unit tests compare
 * them against the server's own values (tests/fixtures/server-validators.json).
 */

/** Statuses in which a patient may still cancel: before payment is captured. */
export const PATIENT_CANCELLABLE_STATUSES: ReadonlySet<string> = new Set(["created", "awaiting_payment"]);

export function canPatientCancel(statusCode: string): boolean {
  return PATIENT_CANCELLABLE_STATUSES.has(statusCode);
}
